// extracted by mini-css-extract-plugin
export default {"wrapper":"LsUAmPRr5mk9GCV4fMEp","titleContainer":"ezce3L8RM7MAf5CREMFv"};